/* global EmblaCarousel */

const Usp = (function UspModule() {
  const DESKTOP_BREAKPOINT = 1024;
  const RESIZE_DEBOUNCE = 150;

  let viewport;
  let emblaApi;
  let resizeTimer;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  function initEmbla() {
    if (!viewport || typeof EmblaCarousel === "undefined") return;
    if (emblaApi) return;

    emblaApi = EmblaCarousel(viewport, {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps",
    });
  }

  function destroyEmbla() {
    if (emblaApi) {
      emblaApi.destroy();
      emblaApi = null;
    }
  }

  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (isDesktop()) {
        destroyEmbla();
      } else {
        initEmbla();
      }
    }, RESIZE_DEBOUNCE);
  }

  function cacheDOM() {
    viewport = document.querySelector("[data-usp-carousel]");
    return !!viewport;
  }

  return {
    init() {
      if (!cacheDOM()) return;

      if (isDesktop()) {
        destroyEmbla();
      } else {
        initEmbla();
      }

      window.addEventListener("resize", handleResize);
    },
    destroy() {
      clearTimeout(resizeTimer);
      destroyEmbla();
      window.removeEventListener("resize", handleResize);
    },
  };
})();

document.addEventListener("DOMContentLoaded", Usp.init);
